export const PRODUCT_TOUR_RESTART_EVENT = 'terra-product-tour-restart';

export const requestProductTourRestart = ({
  tourId,
  storageKey,
}: {
  tourId: string;
  storageKey: string;
}): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.removeItem(storageKey);
  window.dispatchEvent(
    new CustomEvent(PRODUCT_TOUR_RESTART_EVENT, { detail: { tourId } }),
  );
};
